const config = {
    ROOT_URL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://18.139.0.14:1477",
    DL_URL: process.env.REACT_APP_DEBUG_DL_ROUTE ? process.env.REACT_APP_DEBUG_DL_ROUTE: '',
}
export default config
